import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import Entry from "./Entry";
import { defined } from "@entrilia/shared/utilities/typeHelper";

createRoot(defined(document.getElementById("root"))).render(
  <React.StrictMode>
    <BrowserRouter>
      <Entry />
    </BrowserRouter>
  </React.StrictMode>
);
